"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.stepsPropTypes = exports.phasesPropTypes = exports.dataPropType = exports.backButtonPropTypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var backButtonPropTypes = _propTypes["default"].shape({
  url: _propTypes["default"].string,
  text: _propTypes["default"].string
});
exports.backButtonPropTypes = backButtonPropTypes;
var stepsPropTypes = _propTypes["default"].shape({
  selected: _propTypes["default"]["boolean"],
  label: _propTypes["default"].string
});
exports.stepsPropTypes = stepsPropTypes;
var phasesPropTypes = _propTypes["default"].shape({
  previousCta: backButtonPropTypes,
  steps: _propTypes["default"].arrayOf(stepsPropTypes),
  nextSteps: _propTypes["default"].string,
  layout: _propTypes["default"].string
});
exports.phasesPropTypes = phasesPropTypes;
var dataPropType = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  phases: _propTypes["default"].arrayOf(phasesPropTypes)
});
exports.dataPropType = dataPropType;